module.exports = __webpack_public_path__ + "static/image/company/pc/image_conduct_2.jpg?aa70c298";